<template>
  <div :data-id="panelId" class="flex flex-col">
    <div
      :data-id="panelId"
      class="px-6 py-5 border-b bg-pure-white border-slate-400"
    >
      <div
        :data-id="panelId"
        class="flex items-center justify-between gap-6 mb-2"
      >
        <div :data-id="panelId" class="flex items-center gap-2">
          <div
            :data-id="panelId"
            class="flex-shrink-0 w-4 h-4 rounded-full"
            :style="{ backgroundColor: curriculum.color }"
          ></div>
          <div :data-id="panelId" :title="curriculum.name">
            <BlTextSubtitle1
              :data-id="panelId"
              :text="curriculum.name"
              class="line-clamp-2"
            />
          </div>
        </div>
        <BlIcon icon="close" :clickable="true" />
      </div>
      <div :data-id="panelId" class="mb-2">
        <BlTextBody2
          v-if="!curriculum.description"
          :data-id="panelId"
          text="No description"
          class="italic"
        />
        <BlTextBody2 :data-id="panelId" :text="curriculum.description" class="whitespace-pre-line" />
      </div>
      <div :data-id="panelId">
        <BlTextBody2
          :data-id="panelId"
          :text="`${curriculum.number_of_targets} target(s)`"
        />
      </div>
    </div>
    <div
      v-for="target in curriculum.targets"
      :key="target.id"
      :data-id="panelId"
      class="flex items-center justify-between gap-3 px-6 py-4 border-b border-slate-400"
    >
      <div :data-id="panelId" class="flex flex-col gap-1 truncate">
        <BlTextSubtitle3
          :data-id="panelId"
          class="truncate text-slate-1000"
          :text="target.name"
          :title="target.name"
        />
        <BlTextBody2 :data-id="panelId" :text="targetTypes[target.type]" />
      </div>
    </div>
  </div>
</template>

<script>
import BlIcon from "../../BlIcon.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";

export default {
  name: "RepositoryCurriculumDetails",
  props: ["curriculum", "panelId"],
  components: {
    BlIcon,
    BlTextBody2,
    BlTextSubtitle1,
    BlTextSubtitle3
  },
  data() {
    return {
      targetTypes: {
        "Target::Percentage": "Percentage",
        "Target::Pir": "Partial interval recording",
        "Target::Duration": "Duration",
        "Target::Frequency": "Frequency",
        "Target::Prompting": "Prompting"
      }
    };
  },
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/repository/curricula/PanelDetails.vue